/* eslint-disable default-case */
import axios from "axios";
import React, { useState, useEffect } from "react";
import moment from "moment";
import jwt_decode from "jwt-decode";
import { Link, useHistory, useParams, useLocation } from "react-router-dom";
import withAuth from "../../components/auth";
import { injectIntl, useIntl, FormattedMessage } from "react-intl";

function Teams(props) {
  const intl = useIntl();
  const history = useHistory();
  const [searchName, setSearchName] = useState("");
  const [teams, setTeams] = useState([]);
  const [teamsVisible, setTeamsVisible] = useState([]);

  useEffect(() => {
    loadTeams();
  }, []);

  useEffect(() => {
    var filtered = teams;
    if (searchName != "") {
      filtered = filtered.filter((item) =>
        item.name.toLowerCase().includes(searchName.toLowerCase())
      );
    }

    setTeamsVisible(filtered);
  }, [searchName]);

  function loadTeams() {
    let url = "/api/v1/teams/";

    axios
      .get(url, {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      })
      .then((res) => {
        let itens = res.data;
        console.log("itens", itens);
        setTeams(itens);
        setTeamsVisible(itens);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          localStorage.removeItem("token");
          window.open("/", "_self");
        }
      });
  }

  function renderBreadcrumb() {
    return (
      <div className="row page-titles">
        <div className="col p-0">
          <h4>
            <FormattedMessage id="app.welcome-1" />,{" "}
            <span>
              <FormattedMessage id="app.welcome-2" />
            </span>
          </h4>
        </div>
        <div className="col p-0">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={"/"} title="Dashboard">
                <FormattedMessage id="app.breadcrumb.dashboard" />
              </Link>
            </li>
            <li className="breadcrumb-item active">
              <FormattedMessage id="app.breadcrumb.teams" />
            </li>
          </ol>
        </div>
      </div>
    );
  }

  function renderFilters() {
    return (
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <form className="form-custom content-filter">
                <div className="filter">
                  <div className="form-row">
                    <div className="col-12">
                      <h2 className="card-title">
                        <FormattedMessage id="calls.registered.filter.title" />
                      </h2>
                    </div>
                    <div className="form-group col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <label>
                        <FormattedMessage id="calls.inscriptions.event.finalist.filter-name" />
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Nome da equipe"
                        value={searchName}
                        onChange={({ target }) => setSearchName(target.value)}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function renderTeams() {
    return (
      <div className="table-responsive">
        {teamsVisible.length ? (
          <table className="table verticle-middle table-lista-big">
            <thead>
              <tr>
                <th scope="col">
                  <FormattedMessage id="calls.inscriptions.event.finalist.filter-name" />
                </th>
                <th scope="col">
                  <FormattedMessage id="chamada" />
                </th>
                <th scope="col" className="table-right">
                  <FormattedMessage id="acoes" />
                </th>
              </tr>
            </thead>
            <tbody>
              {teamsVisible.map((team, index) => {
                return (
                  <tr key={index}>
                    <td>{team.name}</td>
                    <td>{team.event.name}</td>
                    <td className="table-right">
                      <span>
                        <Link
                          to={`/team/${team.id}`}
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Editar"
                        >
                          <i className="fa fa-pencil color-muted m-r-5"></i>{" "}
                        </Link>
                        <Link
                          to={`/team/remove/${team.id}`}
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Remover"
                          onClick={(e) => {
                            e.preventDefault();
                            if (
                              window.confirm(
                                intl.formatMessage({
                                  id: "delete.team",
                                })
                              ) == true
                            ) {
                              axios
                                .delete(`/api/v1/team/${team.id}`, {
                                  headers: {
                                    "x-access-token":
                                      localStorage.getItem("token"),
                                  },
                                })
                                .then((res) => {
                                  loadTeams();
                                })
                                .catch((error) => {
                                  if (error.response.status === 401) {
                                    localStorage.removeItem("token");
                                    window.open("/", "_self");
                                  }
                                });
                            } else {
                              console.log("não mexe");
                            }
                          }}
                        >
                          <i class="fa fa-close color-danger"></i>{" "}
                        </Link>
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <h2>
            <FormattedMessage id="loading" />
          </h2>
        )}
      </div>
    );
  }

  return (
    <div className="content-body">
      <div className="container-fluid">
        {renderBreadcrumb()}
        {renderFilters()}

        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h1 className="card-title">
                  <FormattedMessage id="app.menu.teams-all" />
                </h1>
                {renderTeams()}
                <div className="form-row">
                  <div className="form-group col-12">
                    <Link
                      to={"/new-team"}
                      className="btn btn-primary"
                      title="Novo Usuário"
                    >
                      <FormattedMessage id="app.breadcrumb.teams.new" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default injectIntl(withAuth(Teams));
